function initCollectionShowcaseTabs() {
  const tabs = document.querySelectorAll('.collection-image-showcase__tab');
  const groups = document.querySelectorAll('.collection-image-showcase__images-group');
  if (groups.length) groups[0].classList.add('active');
  let last = null;

  const activate = (el) => {
    const id = el.dataset.tabId;
    tabs.forEach(t => t.classList.remove('active'));
    el.classList.add('active');
    groups.forEach(g => g.classList.toggle('active', g.dataset.imagesGroup === id));
    last = el;
  };

  tabs.forEach(tab => {
    tab.addEventListener('mouseenter', () => activate(tab));
    tab.addEventListener('focus', () => activate(tab));
    tab.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activate(tab);
      }
    });
    tab.addEventListener('touchstart', e => {
      if (last !== tab) {
        e.preventDefault();
        activate(tab);
      } else if (tab.href) {
        window.location.href = tab.href;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initCollectionShowcaseTabs);
document.addEventListener('shopify:section:load', e => {
  if (e.target.querySelector('.collection-image-showcase')) initCollectionShowcaseTabs();
});
if (document.readyState !== 'loading') setTimeout(initCollectionShowcaseTabs, 100);
